<template>
  <div class="slide" id="slide_results" v-if="isVisibleSlide('results')">
    <div class="slide-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-no-padding">
            <div class="results-box">
              <div v-if="$store.state.firstName !== ''">
                Great - thanks for signing, {{ $store.state.firstName }}!
              </div>
              <div>Now, here’s how you scored in the quiz:</div>
              <div class="score">{{ $store.state.result }} out of 7!</div>
            </div>
            <div class="content-wrapper">
              <div class="highlight">Will you share the quiz to see how your friends’ first aid knowledge compares?</div>
              <div class="buttons-container">
                <button class="btn btn-light red" @click="gotoSlide('share'); analytics('results', 'clicked yes share');">YES</button>
                <button class="btn btn-light" @click="gotoSlide('final'); analytics('results', 'clicked no share');">No</button>
              </div>
              <button class="btn btn-skip" @click="gotoSlide('answers'); analytics('results', 'clicked show answers');">See correct answers</button>
              <!--
              <button class="btn btn-skip" @click="showAnswers = !showAnswers; analytics('results', 'clicked show answers');">See correct answers</button>
              <div class="answers container" v-show="showAnswers">
                <div class="row">
                  <div :key="index" v-for="(q, index) in $store.state.questions" class="col-lg-4">
                    <div class="answer-box" @click="q.showOverlay = !q.showOverlay" :class="{wrong: q.userAnswer != q.correctAnswer}">
                      <img :src="require('@/assets/img/q_'+index+'.jpg')" class="answer-img">
                      <img :src="require('@/assets/img/answer_correct.png')" v-show="q.userAnswer == q.correctAnswer" class="answer-icon">
                      <img :src="require('@/assets/img/answer_wrong.png')" v-show="q.userAnswer != q.correctAnswer" class="answer-icon">
                      <div class="answer-label">{{ index + 1 }}. {{ q.correctAnswer }}</div>
                      <div class="overlay" v-show="q.showOverlay">
                        <div><strong>{{ index + 1 }}. {{ q.text }}</strong></div>
                        <div v-html="q.resultText" class="explanation"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div class="answer-info-box">
                      <div class="answer-info-box-left">
                        This is a quick quiz to help you test some basic first aid knowledge, but it’s no substitute for full training and guidance. For detailed first aid advice, see the <a href="https://www.nhs.uk/conditions/first-aid/" target="_blank">NHS website</a>, <a href="http://www.sja.org.uk/sja/first-aid-advice.aspx" target="_blank">St John Ambulance</a> or the <a href="https://www.redcross.org.uk/first-aid" target="_blank">British Red Cross</a>.
                      </div>
                      <div class="answer-info-box-right">
                        <div class="buttons-container">
                          <button class="btn btn-light red" @click="gotoSlide('share'); analytics('results', 'clicked yes share');">Now I'm ready to share</button>
                          <button class="btn btn-light" @click="gotoSlide('final'); analytics('results', 'clicked no share');">Next</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Results',
  props: ['gotoSlide', 'isVisibleSlide', 'analytics'],
  data () {
    return { 
      showAnswers: false
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.slide-content {
  font-size: 20px;
  @media only screen and (max-width: 768px) {
    text-align: center;
    font-size: 18px;
  }
  .container {
    box-shadow: 0px 0px 10px rgba(70,70,70,0.1);
    @media only screen and (max-width: 768px) {
      box-shadow: none;
    }
  }
  .col-no-padding {
    padding: 0;
  }
  .result-text-container {
    margin-bottom: 10px;
  }
  .content-wrapper {
    padding: 20px 20px 100px 20px;
  }
}
.results-box {
  background: #a70000;
  color:#fff;
  text-align: center;
  padding: 70px 20px 60px 20px;
  font-size: 19px;
  background-image: url('../assets/img/red-bg.jpg');
  background-size: cover;
  @media only screen and (max-width: 768px) {
    padding: 45px 20px 35px 20px;
  }
  .score {
    font-size: 36px;
    font-weight: 600;
    @media only screen and (max-width: 768px) {
      margin-top: 10px;
      font-size: 22px;
    }
  }
}
.highlight {
  color: #cd171e;
  font-weight: 600;
  margin-top: 40px;
  font-size: 20px;
  margin: 50px auto 10px auto;
  max-width: 600px;
  @media only screen and (max-width: 768px) {
    margin: 10px auto 10px auto;
    font-size: 18px;
    font-weight: 600;
  }
}
.buttons-container {
  margin-top: 30px;
  margin-bottom: 20px;
  button {
    display: inline-block;
    margin: 0 20px 0 0;
    font-size: 17px;
    min-width: 230px;
    padding: 17px 35px;
    @media only screen and (max-width: 768px) {
     width: 100%;
     margin: 0 0 15px 0;
    }
  }
}
.answers {
  box-shadow: none !important;
  margin-top: 50px;
  .answer-box {
    text-align: left;
    color: #fff;
    position: relative;
    margin-bottom: 20px;
    cursor: pointer;
    .answer-img {
      width: 100%;
      @media only screen and (max-width: 992px) {
        display: none;
      }
    }
    .answer-icon {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 50px;
      height: 50px;
      @media only screen and (max-width: 992px) {
        display: none;
      }
    }
    .answer-label {
      background: #1cb58d;
      padding: 15px;
      font-size: 18px;
      @media only screen and (max-width: 992px) {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: #1cb58d;
      padding: 25px;
      font-size: 14px;
      @media only screen and (max-width: 992px) {
        bottom: auto;
        height: auto;
        position: relative;
      }
      .explanation {
        margin-top: 15px;
      }
    }
    &.wrong {
      .answer-label {
        background: #cd171e;
      }
      .overlay {
        background: #cd171e;
      }
    }
  }
  .answer-info-box {
    background: #f9f9f9;
    .answer-info-box-left {
      vertical-align: middle;
      width: 50%;
      display: inline-block;
      text-align: left;
      padding: 72px 30px;
      font-size: 18px;
      @media only screen and (max-width: 992px) {
        width: 100%;
        padding: 20px 20px 0 20px;
        font-size: 16px;
      }
      a {
        color: #000;
        text-decoration: underline;
      }
    }
    .answer-info-box-right {
      vertical-align: middle;
      width: 50%;
      display: inline-block;
      padding: 0 20px;
      @media only screen and (max-width: 992px) {
        width: 100%;
      }
      button {
        margin: 10px auto;
        width: 270px;
        @media only screen and (max-width: 992px) {
          width: 100%;
          font-size: 16px;
        }
      }
    }
  }
}
</style>